import API_BASE_URL from "../config";

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const handle = async (res) => {
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `Request failed with status ${res.status}`);
  }
  const text = await res.text();
  return text ? JSON.parse(text) : null;
};

export const getLists = () =>
  fetch(`${API_BASE_URL}/api/checklists/lists`, { headers: authHeaders() }).then(handle);

export const createList = (name) =>
  fetch(`${API_BASE_URL}/api/checklists/lists`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ name }),
  }).then(handle);

export const renameList = (listId, name) =>
  fetch(`${API_BASE_URL}/api/checklists/lists/${listId}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify({ name }),
  }).then(handle);

export const deleteList = (listId) =>
  fetch(`${API_BASE_URL}/api/checklists/lists/${listId}`, {
    method: "DELETE",
    headers: authHeaders(),
  }).then(handle);

export const getItemsByList = (listId) =>
  fetch(`${API_BASE_URL}/api/checklists/lists/${listId}/items`, { headers: authHeaders() }).then(handle);

export const getAllItems = () =>
  fetch(`${API_BASE_URL}/api/checklists/items`, { headers: authHeaders() }).then(handle);

export const getStarredItems = () =>
  fetch(`${API_BASE_URL}/api/checklists/items?starred=true`, { headers: authHeaders() }).then(handle);

export const createItem = (payload) =>
  fetch(`${API_BASE_URL}/api/checklists/items`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  }).then(handle);

export const updateItem = (itemId, payload) =>
  fetch(`${API_BASE_URL}/api/checklists/items/${itemId}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  }).then(handle);

export const toggleComplete = (itemId) =>
  fetch(`${API_BASE_URL}/api/checklists/items/${itemId}/complete`, {
    method: "PATCH",
    headers: authHeaders(),
  }).then(handle);

export const toggleStar = (itemId) =>
  fetch(`${API_BASE_URL}/api/checklists/items/${itemId}/star`, {
    method: "PATCH",
    headers: authHeaders(),
  }).then(handle);

export const deleteItem = (itemId) =>
  fetch(`${API_BASE_URL}/api/checklists/items/${itemId}`, {
    method: "DELETE",
    headers: authHeaders(),
  }).then(handle);
